/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentStats
 */
export interface DocumentStats {
    /**
     * 
     * @type {string}
     * @memberof DocumentStats
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStats
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentStats
     */
    filesize: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentStats
     */
    page_count: number | null;
}

/**
 * Check if a given object implements the DocumentStats interface.
 */
export function instanceOfDocumentStats(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "filesize" in value;
    isInstance = isInstance && "page_count" in value;

    return isInstance;
}

export function DocumentStatsFromJSON(json: any): DocumentStats {
    return DocumentStatsFromJSONTyped(json, false);
}

export function DocumentStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'filesize': json['filesize'],
        'page_count': json['page_count'],
    };
}

export function DocumentStatsToJSON(value?: DocumentStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'filesize': value.filesize,
        'page_count': value.page_count,
    };
}

